document.addEventListener('DOMContentLoaded', () => {

	const
	heroCarouselAnim = '#hero-carousel',
	blockGomita = '.bloque-gomitas',
	geometryies = '.geometry-img';
	
	let
	tl = gsap.timeline(),
	move1 = {
		ease: "slow(0.6, 1.2)",
		autoAlpha: 0,
		scale: .1,
		x: -1000,
		y: -1000,
		duration: .5,
		stagger: .5
	};
	const randomX = random(10, 20);
	const randomY = random(20, 30);
	const randomDelay = random(0, 1);
	const randomTime = random(3, 5);
	const randomTime2 = random(5, 10);
	const randomAngle = random(8, 12);
	let geometriesCollection = document.querySelectorAll(geometryies);
	TweenMax.set(heroCarouselAnim, { visibility:"visible" });
	TweenMax.set(blockGomita, { visibility:"visible" });
	tl.from(heroCarouselAnim, move1)
	.from(geometryies, {
		ease: "slow(0.6, 1.2)",
		autoAlpha: 0,
		scale: .1,
		x: -1000,
		y: -1000,
		duration: .5,
		stagger: .5,
		onComplete: function() {
			geometriesCollection.forEach(el => {
				moveX(el, 1);
				moveY(el, -1);
				rotate(el, 1);
			});
		}
	});
	
	
	

	
	

	
	

	function rotate(target, direction) {
		TweenLite.to(target, randomTime2(), {
			rotation: randomAngle(direction),
			ease: Sine.easeInOut,
			onComplete: rotate,
			onCompleteParams: [target, direction * -1]
		});
	}

	function moveX(target, direction) {
  
	  TweenLite.to(target, randomTime(), {
	    x: randomX(direction),
	    ease: Sine.easeInOut,
	    onComplete: moveX,
	    onCompleteParams: [target, direction * -1]
	  });
	}

	function moveY(target, direction) {
  
	  TweenLite.to(target, randomTime(), {
	    y: randomY(direction),
	    ease: Sine.easeInOut,
	    onComplete: moveY,
	    onCompleteParams: [target, direction * -1]
	  });
	}

	function random(min, max) {
	  const delta = max - min;
	  return (direction = 1) => (min + delta * Math.random()) * direction;
	}
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	/*
	tl.set(carouselAndGeometries, {
		scale: .1,
		x: -1000,
		y: -1000
	})
	.to(carouselAndGeometries, {
		scale: 1,
		x: 0,
		y: 0,
		duration: .5,
		stagger: .5
	})
	*/
	
	
});